import { render, staticRenderFns } from "./Smallapp.vue?vue&type=template&id=64a6888a&scoped=true&"
import script from "./Smallapp.vue?vue&type=script&lang=js&"
export * from "./Smallapp.vue?vue&type=script&lang=js&"
import style0 from "./Smallapp.vue?vue&type=style&index=0&id=64a6888a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../crossBorder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6888a",
  null
  
)

export default component.exports